var icon = require('vue-svgicon');
// console.log('');
icon.register({
  'folder': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: `<path pid="0" d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"/>`
  }
});



// WEBPACK FOOTER //
// ./src/icons/folder.js